export default __webpack_public_path__ + "static/media/blog-img-3.bb6252ea.jpg";